import React, { useState, useEffect } from 'react';
// import { ChevronDown } from 'lucide-react';
import styles from './ScrollIndicator.module.css';


const ScrollIndicator = () => {
    const [showIndicator, setShowIndicator] = useState(false);
    const [opacity, setOpacity] = useState(1);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;

            const hasMoreContent = documentHeight > windowHeight;

            if (!hasMoreContent) {
                setShowIndicator(false);
                return;
            }

            const scrollPercent = scrollTop / (documentHeight - windowHeight);

            if (scrollPercent < 0.2) {
                setShowIndicator(true);
                setOpacity(1 - (scrollPercent / 0.2));
            } else {
                setShowIndicator(false);
            }
        };

        handleScroll();

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
        };
    }, []);

    if (!showIndicator) return null;

    return (
        <div className={styles.scrollIndicator} style={{ opacity }}>More content below</div>
    );

};

export default ScrollIndicator;